import { useProviderProps } from "@react-spectrum/provider";
import _react, { forwardRef } from "react";
import { filterDOMProps } from "@react-aria/utils";
import { classNames, useDOMRef, useStyleProps } from "@react-spectrum/utils";
import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/statuslight/vars.css
var $dd4b8a3e2f1fd49bf33fcb2d525d0bc5$exports = {};
$dd4b8a3e2f1fd49bf33fcb2d525d0bc5$exports = {
  "spectrum-StatusLight": "_spectrum-StatusLight_71d0f",
  "spectrum-StatusLight--neutral": "_spectrum-StatusLight--neutral_71d0f",
  "is-disabled": "_is-disabled_71d0f",
  "spectrum-StatusLight--negative": "_spectrum-StatusLight--negative_71d0f",
  "spectrum-StatusLight--notice": "_spectrum-StatusLight--notice_71d0f",
  "spectrum-StatusLight--positive": "_spectrum-StatusLight--positive_71d0f",
  "spectrum-StatusLight--info": "_spectrum-StatusLight--info_71d0f",
  "spectrum-StatusLight--active": "_spectrum-StatusLight--active_71d0f",
  "spectrum-StatusLight--celery": "_spectrum-StatusLight--celery_71d0f",
  "spectrum-StatusLight--yellow": "_spectrum-StatusLight--yellow_71d0f",
  "spectrum-StatusLight--fuchsia": "_spectrum-StatusLight--fuchsia_71d0f",
  "spectrum-StatusLight--indigo": "_spectrum-StatusLight--indigo_71d0f",
  "spectrum-StatusLight--seafoam": "_spectrum-StatusLight--seafoam_71d0f",
  "spectrum-StatusLight--chartreuse": "_spectrum-StatusLight--chartreuse_71d0f",
  "spectrum-StatusLight--magenta": "_spectrum-StatusLight--magenta_71d0f",
  "spectrum-StatusLight--purple": "_spectrum-StatusLight--purple_71d0f"
};
var $dd4b8a3e2f1fd49bf33fcb2d525d0bc5$$interop$default = $parcel$interopDefault($dd4b8a3e2f1fd49bf33fcb2d525d0bc5$exports);

function $dc530db4434f30bfa8656c892b766522$var$StatusLight(props, ref) {
  let _useProviderProps = useProviderProps(props),
      {
    variant,
    children,
    isDisabled,
    role
  } = _useProviderProps,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(_useProviderProps, ["variant", "children", "isDisabled", "role"]);

  let domRef = useDOMRef(ref);
  let {
    styleProps
  } = useStyleProps(otherProps);

  if (!children && !props['aria-label']) {
    console.warn('If no children are provided, an aria-label must be specified');
  }

  if (!role && (props['aria-label'] || props['aria-labelledby'])) {
    console.warn('A labelled StatusLight must have a role.');
  }

  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, filterDOMProps(otherProps, {
    labelable: !!role
  }), styleProps, {
    role: role,
    className: classNames($dd4b8a3e2f1fd49bf33fcb2d525d0bc5$$interop$default, 'spectrum-StatusLight', "spectrum-StatusLight--" + variant, {
      'is-disabled': isDisabled
    }, styleProps.className),
    ref: domRef
  }), children);
}
/**
 * Status lights are used to color code categories and labels commonly found in data visualization.
 * When status lights have a semantic meaning, they should use semantic variant colors.
 */


export let StatusLight = /*#__PURE__*/forwardRef($dc530db4434f30bfa8656c892b766522$var$StatusLight);
//# sourceMappingURL=module.js.map
